<template>
  <div>
    <template v-if="state === 'validating'">
      <div class="has-text-centered">
        <h2 v-text="$wording.resetpw.form_1" />
        <p v-text="$wording.resetpw.form_2" />
      </div>
    </template>
    <template v-else>
      <div class="has-text-centered">
        <h2 v-text="$wording.resetpw.form_3" />
        <p v-text="$wording.resetpw.form_4" />
      </div>
      <validation-observer
        id="reset-password"
        ref="reset-password"
        tag="form"
        class="small-form"
        @submit.prevent
      >
        <div class="password-requirements has-text-right m-t-sm">
          <p class="is-marginless">
            <a
              @click.prevent="showPasswordRequirements"
            >Password requirements</a>
          </p>
        </div>
        <div class="field">
          <input-text-with-validation
            id="password"
            v-model="password"
            name="password"
            type="password"
            placeholder="Password"
            rules="required"
            autocomplete="off"
          />
        </div>
        <div class="field">
          <input-text-with-validation
            id="passwordConfirm"
            v-model="confirmPassword"
            name="passwordConfirm"
            type="password"
            rules="required|confirmed:password"
            placeholder="Re-enter Password"
            autocomplete="off"
          />
        </div>
        <div class="control has-text-centered">
          <button
            class="button submit-button is-primary"
            :class="{ 'is-loading': doingAjax }"
            @click.prevent="resetPassword"
          >
            Submit
          </button>
        </div>
      </validation-observer>
    </template>
  </div>
</template>

<script>
import InputTextWithValidation from "@/components/common/InputTextWithValidation";
export default {
  components: {
    InputTextWithValidation,
  },
  data() {
    return {
      state: 'validating',
      password: '',
      confirmPassword: '',
      doingAjax: false,
      authToken: '',
      userId: '',
    };
  },
  async beforeMount() {
    // TODO: REMOVE THIS AT THE END!
    if (this.$route.query.emailToken === 'ABC' && this.$route.query.userId === 'DEF') {
      this.state = 'valid';
      return;
    }
    if (this.$route.query.emailToken && this.$route.query.userId) {
      this.state = 'validating';
      this.authToken = encodeURIComponent(this.$route.query.emailToken);
      this.userId = this.$route.query.userId;
      const isValid = await this.$store.dispatch('login/validateToken', {
        userId: this.userId,
        token: this.authToken,
      });
      if (isValid) {
        this.state = 'valid';
      } else {
        this.$router.push({ name: 'reset-password-error' });  
      }
    } else {
      this.$router.push({ name: 'reset-password-error' });
    }
  },
  methods: {
    async resetPassword() {
      const valid = await this.$refs['reset-password'].validate();
      if (!valid) {
        return false;
      }

      this.doingAjax = true;
      const data = await this.$store.dispatch('login/resetPassword', {
        userId: this.userId,
        password: this.password,
        authToken: this.authToken,
      });
      this.doingAjax = false;

      if(data) {
        this.$success('Your password has been updated!');
        this.$router.push({ name: 'login' });
      }
    },
  },
};
</script>

<style>

</style>